<template>
  <!-- <el-breadcrumb class='app-levelbar' separator='/'>
    <el-breadcrumb-item v-for='(item,index)  in levelList' :key='item.path'>
      <span v-if='item.redirect==='noredirect'||index==levelList.length-1' class='no-redirect'>{{item.name}}</span>
      <router-link v-else :to='item.redirect||item.path'>{{item.name}}</router-link>
    </el-breadcrumb-item> -->
    <!-- <el-breadcrumb-item v-for='(item,index)  in detail' :key='item.name'>
      <span class='no-redirect'>{{item}}</span>
    </el-breadcrumb-item> -->
  <!-- </el-breadcrumb> -->


  <div class='app-levelbar'>
    <!-- <div v-for='(item,index)  in levelList' :key='item.path'>
      <span v-if='index==levelList.length-1' class='no-redirect'>{{item.name}}</span>
    </div> -->
    <div v-for="(item,index)  in levelList" :key="item.path" style="float:left;margin-left:20px;">
      <span v-if='index==levelList.length-1' class="no-redirect">{{item.name}} </span>
      <span v-if='item.redirect==="noredirect" && index!=levelList.length-1' class="no-redirect">{{item.name}}&nbsp;&nbsp;&nbsp;&nbsp;></span>
      <!-- <router-link v-else :to="item.redirect||item.path">{{item.name}}</router-link> -->
    </div>
  </div>

</template>

<script>
export default {
  created() {
    this.init();
  },
  data() {
    return {
      levelList: null,
      detail: []
    };
  },
  methods: {
    getBreadcrumb() {
      let matched = this.$route.matched.filter(item => item.name);
      const first = matched[0];
      // if (first && (first.name !== '首页' || first.path !== '')) {
      //   matched = [{ name: '首页', path: '/welcome' }].concat(matched);
      // }
      this.levelList = matched;
    },
    init() {
      this.getBreadcrumb();
      this.detail = [];
      let detail = '';
      if (this.$route.params.breadcrumb) {
        detail = this.$route.params.breadcrumb;
        localStorage.setItem('detail', detail);
      } else if (this.$route.name === '广告位管理' || this.$route.name === '订单管理') {
        detail = localStorage.getItem('detail');
      }
      if (detail) {
        this.detail = detail.split(',');
      }
    }
  },
  watch: {
    $route() {
      this.init();
    }
  }
};
</script>

<style rel='stylesheet/scss' lang='scss' scoped>
.app-levelbar {
  display: inline-block;
  font-size: 14px;
  line-height: 50px;
  margin-left: 10px;
  .no-redirect {
    color: #999999;
    cursor: text;
  }
}
</style>



// WEBPACK FOOTER //
// Levelbar.vue?a9d44fb8